import { useCallback, useEffect, useState } from 'react';
/**
 * Local storage hook
 */
export function useLocalStorage(key, initialValue) {
    const readLocalStorageValue = useCallback(() => {
        if (typeof window === 'undefined') {
            return initialValue;
        }
        try {
            const item = window.localStorage.getItem(key);
            return item ? JSON.parse(item) : initialValue;
        }
        catch (error) {
            console.error(error);
            return initialValue;
        }
    }, [key, initialValue]);
    const [storedValue, setStoredValue] = useState(readLocalStorageValue());
    const setValue = useCallback((value) => {
        try {
            const valueToStore = value instanceof Function ? value(storedValue) : value;
            setStoredValue(valueToStore);
            if (typeof window !== 'undefined') {
                window.localStorage.setItem(key, JSON.stringify(valueToStore));
                window.dispatchEvent(new Event('local-storage'));
            }
        }
        catch (error) {
            console.error(error);
        }
    }, [storedValue, setStoredValue]);
    const localStorageEventHandler = useCallback(() => {
        setStoredValue(readLocalStorageValue());
    }, [setStoredValue, readLocalStorageValue]);
    useEffect(() => {
        window.addEventListener('local-storage', localStorageEventHandler);
        return () => window.removeEventListener('local-storage', localStorageEventHandler);
    }, [localStorageEventHandler]);
    return [storedValue, setValue];
}
